/*** IMPORTS FROM imports-loader ***/
var _ = require("tpl-shim/fake-lodash.js");

export default function(data) {
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '<div class="progress-percentage">\n  ';
 if (data.doneUploading){ ;
__p += '\n    Processing...\n  ';
 } else { ;
__p += '\n    Uploading ' +
__e(data.percent) +
'%\n  ';
 } ;
__p += '\n</div>\n';
return __p
}
